import { render, staticRenderFns } from "./DeviceShare.vue?vue&type=template&id=b0815ba8&scoped=true"
import script from "./DeviceShare.vue?vue&type=script&lang=js"
export * from "./DeviceShare.vue?vue&type=script&lang=js"
import style0 from "./DeviceShare.vue?vue&type=style&index=0&id=b0815ba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0815ba8",
  null
  
)

export default component.exports